var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZestLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 31,
    viewBox: "0 0 96 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.077 6.78116H4.41231L5.32797 0.349709H31.0808L14.3758 22.6736H27.504L26.4224 29.6354H0L17.077 6.78116Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7338 23.1193L46.6922 29.6298H29.5752L34.2679 0.349709H51.3849L50.3033 7.10838H41.1296L40.3799 11.8981H48.8955L47.8997 18.2449H39.3384L38.5486 23.1193H47.7338Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8204 6.42581L75.0719 29.7539H82.895L86.6435 6.42581H94.9016L96.0003 0.141041L64.0268 0C57.829 0 53.5941 4.05633 53.5941 9.68103C53.5941 13.2973 55.7516 15.0631 59.5859 17.0321C62.1555 18.3579 63.6606 19.001 63.6606 20.6878C63.6606 22.1772 62.4759 23.2604 60.4386 23.2604C57.9549 23.2604 55.8317 22.0136 53.5082 19.5652L49.4736 25.3083C52.2034 28.5241 55.6257 30.1714 59.5401 30.1714C67.1629 30.1714 71.6039 26.0305 71.6039 20.0052C71.6039 16.2704 69.8927 14.341 66.1443 12.2931C63.5347 10.8488 61.5374 10.2847 61.5374 8.71631C61.5374 7.43002 62.6762 6.38632 64.3072 6.38632C64.7708 6.38632 78.8204 6.42581 78.8204 6.42581Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZestLogo);
export default __webpack_public_path__ + "static/media/zestLogo.89f3440bb435390c98ff0dd332f8a778.svg";
export { ForwardRef as ReactComponent };